import { useQuery } from 'react-query'
import { QUERY_KEYS } from 'src/constants'
import { scanService } from 'src/services/scan.service'

export const useScanBatchIds = (productId?: string) => {
  return useQuery(
    [QUERY_KEYS.SCAN_BATCH_IDS, productId],
    async () => (productId ? await scanService.getBatchIds(productId) : null),
    {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  )
}
